import { render, staticRenderFns } from "./Interface.vue?vue&type=template&id=34e489ae&scoped=true&"
import script from "./Interface.vue?vue&type=script&lang=ts&"
export * from "./Interface.vue?vue&type=script&lang=ts&"
import style0 from "./Interface.vue?vue&type=style&index=0&id=34e489ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e489ae",
  null
  
)

export default component.exports